'use client';

import { Grid2, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { icons } from '@/assets/icons';
import { backgrounds } from '@/assets/materials';
import HexagonalButton from '@/components/bases/HexagonalButton';
import { HOW_IT_WORKS } from '@/global/constants/common';

export const HowItWorksSection = () => {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      minHeight={'852px'}
      padding={{ xs: '32px 24px', md: '80px' }}
      marginY={{ xs: '12px', md: '30px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}
      sx={{
        backgroundImage: `url(${backgrounds.how_it_work_bg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <Stack
        bgcolor={'#0c0e17'}
        className={'top-cut'}
        position={'absolute'}
        top={{ xs: '12px', md: '-30px' }}
        zIndex={1}
        left={'50%'}
        height={{ xs: '12px', md: '30px' }}
        width={{ xs: 'min(160px, 100%)', md: 'min(616px, 100%)' }}
        sx={{ transform: 'translateX(-50%)' }}
      />
      <Stack gap={{ xs: 4, md: 8.5 }} width={'min(1280px, 100%)'} zIndex={2}>
        <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} gap={2} width={'100%'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            fontSize={{ xs: '24px', md: '48px' }}
            lineHeight={{ xs: '32px', md: '68px' }}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            HOW IT WORKS?
          </Typography>
          <Stack width={'195px'} display={{ xs: 'none', md: 'block' }}>
            <HexagonalButton
              onClick={() => window.open('https://support.lfg.inc/hc/en-us/sections/26310359060891-Platform', '_blank')}
              variant={'secondary'}
              label={'FULL GUIDES'}
            />
          </Stack>
          <Stack width={'92px'} display={{ xs: 'block', md: 'none' }}>
            <HexagonalButton variant={'secondary'} size={'small'} width={92}>
              <Image width={24} height={24} src={icons.ic_arrow_right} alt={''} />
            </HexagonalButton>
          </Stack>
        </Stack>
        <Grid2 container width={'100%'} spacing={{ xs: 2, md: 4 }}>
          {HOW_IT_WORKS.map(item => (
            <Grid2 key={item.title} size={{ xs: 12, sm: 6, md: 4 }}>
              <Image
                priority
                width={400}
                height={494}
                alt={item.title}
                src={item.src}
                className={'w-full h-[398px] hidden sm:h-[494px] md:block object-contain'}
              />
              <Image
                priority
                width={327}
                height={398}
                alt={item.title}
                src={item.srcMobile}
                className={'w-full h-[398px] block sm:h-[494px] md:hidden object-contain'}
              />
            </Grid2>
          ))}
        </Grid2>
      </Stack>
      <Stack
        bgcolor={'#0c0e17'}
        className={'bottom-cut'}
        position={'absolute'}
        bottom={{ xs: '-12px', md: '-30px' }}
        zIndex={1}
        left={'50%'}
        height={{ xs: '12px', md: '30px' }}
        width={{ xs: 'min(160px, 100%)', md: 'min(616px, 100%)' }}
        sx={{ transform: 'translateX(-50%)' }}
      />
    </Stack>
  );
};
